"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CurrentProjectProvider = exports.useCurrentProjectContext = void 0;
const React = __importStar(require("react"));
const react_router_dom_1 = require("react-router-dom");
const AppRouter_1 = require("src/configeek_assets/src/components/common/AppRouter");
const lodash_1 = __importDefault(require("lodash"));
const ProjectsDataProvider_1 = require("src/configeek_assets/src/components/common/provider/ProjectsDataProvider");
const ProjectUrlProvider_1 = require("src/configeek_assets/src/components/common/provider/ProjectUrlProvider");
const use_custom_compare_1 = require("use-custom-compare");
const CurrentProjectContext = React.createContext(undefined);
const useCurrentProjectContext = () => {
    const context = React.useContext(CurrentProjectContext);
    if (!context) {
        throw new Error("useCurrentProjectContext must be used within a CurrentProjectContext.Provider");
    }
    return context;
};
exports.useCurrentProjectContext = useCurrentProjectContext;
const CurrentProjectProvider = (props) => {
    const { projectApiKey } = (0, ProjectUrlProvider_1.useProjectUrlContext)();
    const projectsDataContext = (0, ProjectsDataProvider_1.useProjectsDataContext)();
    // console.log("CurrentProjectProvider: projectApiKey", projectApiKey);
    const projectData = projectsDataContext.getProject(projectApiKey);
    // console.log("CurrentProjectProvider: projectData", projectData);
    if (projectData === undefined) {
        // console.log("CurrentProjectProvider: redirect");
        return React.createElement(react_router_dom_1.Redirect, { to: AppRouter_1.PATH__HOME });
    }
    const value = (0, use_custom_compare_1.useCustomCompareMemo)(() => ({
        projectData
    }), [projectData], lodash_1.default.isEqual);
    // console.log("CurrentProjectProvider: value", value);
    return React.createElement(CurrentProjectContext.Provider, { value: value }, props.children);
};
exports.CurrentProjectProvider = CurrentProjectProvider;
